/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type FeaturesSettingsType from '@jira/spa-apps__project-settings-next-gen-features/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyFeaturesSettings: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof FeaturesSettingsType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-next-gen-features", jiraSpaEntry: "async-project-settings-next-gen-features" */ '@jira/spa-apps__project-settings-next-gen-features/src/index.tsx'
			),
		),
	);

const AsyncFeaturesSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyFeaturesSettings}
		pageId="project-settings-next-gen-features"
		shouldShowSpinner={false}
	/>
);

export default AsyncFeaturesSettings;
